import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { string_type, list_type, lambda_type, unit_type, class_type, record_type, bool_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { getInitialSearchFilters, Page$reflection, SearchFilter, SearchFilter$reflection } from "./Model.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { LoadState$2, GlobalDependencies$reflection, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { effect } from "../../Components/Hooks/ClickOutside.js";
import { append, isEmpty, singleton as singleton_1, filter as filter_3, map, mapIndexed, ofArray, sumBy } from "../../fable_modules/fable-library.3.7.20/List.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { optToStr, decodeUriString, classNames } from "../../Utils.js";
import { dotsLoading, getMaterialIcon, Size, SveaIcon, renderSveaIconBySize } from "../../ViewUtils.js";
import { CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox } from "../../Components/FormFields/FormFields.js";
import { Filter$reflection, Filter_toTranslation_11D407F6 } from "../Search/Model.js";
import { uncurry, compare, equals, partialApply } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { Browser_Types_Event__Event_get_Value, Browser_Types_Event__Event_get_Checked } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { RouterModule_encodeQueryString, RouterModule_nav, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { ofList, FSharpSet__Contains } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { loadSearchResultsV2 } from "../Search/Api.js";
import { setItem } from "../../LocalStorage.js";
import { Convert_serialize } from "../../fable_modules/Fable.SimpleJson.3.21.0/Json.Converter.fs.js";
import { createTypeInfo } from "../../fable_modules/Fable.SimpleJson.3.21.0/TypeInfo.Converter.fs.js";
import { SearchProps, renderSearch } from "../Search/View.js";
import { SearchResultV2 } from "../../CommonTypes.js";
import { InvoiceeProps } from "../Invoicee/View.js";
import { RegisterInvoiceeProps } from "../RegisterInvoicee/View2.js";
import "../../../src/Containers/CustomerContract/View.scss";


export class FilterButtonState extends Record {
    constructor(ShowSearchFilters) {
        super();
        this.ShowSearchFilters = ShowSearchFilters;
    }
}

export function FilterButtonState$reflection() {
    return record_type("Containers.CustomerContract.View.FilterButtonState", [], FilterButtonState, () => [["ShowSearchFilters", bool_type]]);
}

export class FilterButtonProps extends Record {
    constructor(OnClickFilterCheckbox, SearchFilters) {
        super();
        this.OnClickFilterCheckbox = OnClickFilterCheckbox;
        this.SearchFilters = SearchFilters;
    }
}

export function FilterButtonProps$reflection() {
    return record_type("Containers.CustomerContract.View.FilterButtonProps", [], FilterButtonProps, () => [["OnClickFilterCheckbox", lambda_type(SearchFilter$reflection(), lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type))], ["SearchFilters", list_type(SearchFilter$reflection())]]);
}

const renderFilterButton = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2, children, arg_2, children_4;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const state_1 = react.useState(new FilterButtonState(false));
    const wrapperRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(wrapperRef, () => {
        let inputRecord;
        state_1[1]((inputRecord = (state_1[0]), new FilterButtonState(false)));
    }, void 0))();
        return () => disp.Dispose();
    });
    let numberOfActiveFiltersStr;
    const numberOfActiveFilters = sumBy((elem) => (elem.IsChecked ? 1 : 0), props.SearchFilters, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    }) | 0;
    numberOfActiveFiltersStr = ((numberOfActiveFilters === 0) ? "" : toText(printf("(%i)"))(numberOfActiveFilters));
    const filtersContainerClasses = classNames(ofArray([["filters__container", true], ["d-none", !(state_1[0]).ShowSearchFilters]]));
    const children_6 = [(children_2 = [(children = [(arg_2 = getTranslation("Common.Filter"), toText(printf("%s %s"))(arg_2)(numberOfActiveFiltersStr))], react.createElement("span", {}, ...children)), renderSveaIconBySize(new SveaIcon(13), new Size(1))], react.createElement("div", {
        className: "button button--main filters__button",
        onClick: (_arg) => {
            let inputRecord_2;
            state_1[1]((inputRecord_2 = (state_1[0]), new FilterButtonState(!(state_1[0]).ShowSearchFilters)));
        },
    }, ...children_2)), (children_4 = mapIndexed((index, filter) => {
        let inputRecord_1;
        return inputCheckbox((inputRecord_1 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_1.Disabled, Filter_toTranslation_11D407F6(getTranslation)(filter.Filter), partialApply(1, props.OnClickFilterCheckbox, [filter]), filter.IsChecked, toText(printf("search-filter-%i"))(index), inputRecord_1.HTMLProps)));
    }, props.SearchFilters), react.createElement("div", {
        className: filtersContainerClasses,
        ["data-regression"]: "search-filter-container",
    }, ...children_4))];
    return react.createElement("div", {
        id: "search-filter-btn",
        className: "search-container__filters",
        ref: wrapperRef,
    }, ...children_6);
}, "FilterButton", Helpers_equalsButFunctions, void 0, "renderFilterButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\CustomerContract\\View.fs", 71);

export class SearchBarProps extends Record {
    constructor(CurrentSearchString, SearchFilters, OnClickFilterCheckboxFn, UpdateSearchQueryParam, ChangeSearchTextFn) {
        super();
        this.CurrentSearchString = CurrentSearchString;
        this.SearchFilters = SearchFilters;
        this.OnClickFilterCheckboxFn = OnClickFilterCheckboxFn;
        this.UpdateSearchQueryParam = UpdateSearchQueryParam;
        this.ChangeSearchTextFn = ChangeSearchTextFn;
    }
}

export function SearchBarProps$reflection() {
    return record_type("Containers.CustomerContract.View.SearchBarProps", [], SearchBarProps, () => [["CurrentSearchString", string_type], ["SearchFilters", list_type(SearchFilter$reflection())], ["OnClickFilterCheckboxFn", lambda_type(SearchFilter$reflection(), unit_type)], ["UpdateSearchQueryParam", lambda_type(string_type, unit_type)], ["ChangeSearchTextFn", lambda_type(string_type, unit_type)]]);
}

const renderSearchBar = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, props_1, children, props_5, children_2;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const searchTerm = defaultArg(decodeUriString(props.CurrentSearchString), props.CurrentSearchString);
    const filtersButtonHtml = renderFilterButton(new FilterButtonProps((filter, e) => {
        props.OnClickFilterCheckboxFn(new SearchFilter(filter.Filter, Browser_Types_Event__Event_get_Checked(e)));
    }, props.SearchFilters));
    const children_6 = [(children_4 = [(props_1 = [new HTMLAttr(99, "search-input"), new HTMLAttr(65, "search-container__input"), ["data-translation", "CustomerContract.Search"], ["data-regression", "search-input"], new HTMLAttr(159, "text"), new HTMLAttr(128, getTranslation("CustomerContract.Search")), new HTMLAttr(161, searchTerm), new DOMAttr(17, (e_1) => {
        if (e_1.key === "Enter") {
            props.UpdateSearchQueryParam(searchTerm);
        }
    }), new DOMAttr(9, (event) => {
        const target = event.target;
        const prevBeginPos = target.selectionStart | 0;
        const prevEndPos = target.selectionEnd | 0;
        ((e_2) => {
            props.ChangeSearchTextFn(Browser_Types_Event__Event_get_Value(e_2));
        })(event);
        window.requestAnimationFrame((_arg) => {
            target.selectionStart = (prevBeginPos | 0);
            target.selectionEnd = (prevEndPos | 0);
        });
    })], react.createElement("input", keyValueList(props_1, 1))), (children = [getMaterialIcon("search")], react.createElement("button", {
        id: "search-button",
        className: "search-container__button",
        ["data-regression"]: "search-button",
        onClick: (_arg_1) => {
            props.UpdateSearchQueryParam(searchTerm);
        },
    }, ...children)), filtersButtonHtml, (props_5 = [new HTMLAttr(65, "search-container__link"), ["data-translation", "CustomerContract.RegisterInvoicee"], ["data-regression", "register-invoicee-link"], new HTMLAttr(94, RouterModule_encodeParts(ofArray(["CustomerContract", "RegisterInvoicee"]), 1))], (children_2 = [getTranslation("CustomerContract.RegisterInvoicee")], react.createElement("a", keyValueList(props_5, 1), ...children_2)))], react.createElement("div", {
        className: "search-container",
    }, ...children_4))];
    return react.createElement("div", {
        className: "search-bar",
    }, ...children_6);
}, "SearchBar", Helpers_equalsButFunctions, void 0, "renderSearchBar", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\CustomerContract\\View.fs", 141);

export const LazyPages_InvoiceePage = (() => {
    const elemType = react.lazy(() => import("../Invoicee/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_RegisterInvoiceePage = (() => {
    const elemType = react.lazy(() => import("../RegisterInvoicee/View2.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export class CustomerContractProps extends Record {
    constructor(GlobalDependencies, CurrentPage) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.CurrentPage = CurrentPage;
    }
}

export function CustomerContractProps$reflection() {
    return record_type("Containers.CustomerContract.View.CustomerContractProps", [], CustomerContractProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["CurrentPage", Page$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_6, page, children_4, children;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const showCustomerContractState = FSharpSet__Contains(props.GlobalDependencies.Privileges, "FenixWeb.ClientContract.ShowGeneralWrite");
    const searchFromState = react.useState(0);
    const searchToState = react.useState(30);
    const searchStringState = react.useState(void 0);
    const hasReachedMaxResultsState = react.useState(false);
    const searchFiltersState = react.useState(getInitialSearchFilters());
    const searchResultsState = react.useState(new LoadState$2(0));
    const decodeSearchTerm = (searchTerm) => defaultArg(decodeUriString(searchTerm.trim()), searchTerm.trim());
    react.useEffect(() => {
        const matchValue_3 = props.CurrentPage;
        if (matchValue_3.tag === 1) {
            const searchText = matchValue_3.fields[0];
            const resultsTo = 30;
            const resultsFrom = 0;
            const searchTerm_1 = decodeSearchTerm(searchText);
            searchFromState[1](resultsFrom);
            searchToState[1](resultsTo);
            searchStringState[1](searchTerm_1);
            if (hasReachedMaxResultsState[0]) {
            }
            else {
                searchResultsState[1](new LoadState$2(1));
                startImmediate(singleton.Delay(() => singleton.Bind(loadSearchResultsV2(props.GlobalDependencies.ClientNr, encodeURIComponent(searchTerm_1), map((sf_1) => sf_1.Filter, filter_3((sf) => sf.IsChecked, searchFiltersState[0])), resultsFrom, resultsTo), (_arg) => {
                    const result = _arg;
                    const arg = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0]));
                    searchResultsState[1](arg);
                    return singleton.Zero();
                })));
            }
            searchStringState[1](searchText);
        }
    }, [props.GlobalDependencies, props.CurrentPage]);
    let pageContentHtml;
    if (showCustomerContractState) {
        const children_8 = [renderSearchBar(new SearchBarProps(optToStr(searchStringState[0]), searchFiltersState[0], (filter) => {
            const updatedSearchFilters = map((searchFilter) => {
                if (equals(filter.Filter, searchFilter.Filter)) {
                    return filter;
                }
                else {
                    return searchFilter;
                }
            }, searchFiltersState[0]);
            setItem("CustomerContract.Update", "Search.Filters", Convert_serialize(ofList(map((filter_2) => filter_2.Filter, filter_3((filter_1) => filter_1.IsChecked, updatedSearchFilters)), {
                Compare: compare,
            }), createTypeInfo(class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Filter$reflection()]))));
            searchFiltersState[1](updatedSearchFilters);
        }, (searchText_1) => {
            RouterModule_nav(singleton_1("CustomerContract" + RouterModule_encodeQueryString(singleton_1(["q", searchText_1]))), 1, 1);
        }, (arg_7) => {
            searchStringState[1](arg_7);
        })), (children_6 = [(page = props.CurrentPage, (page.tag === 1) ? renderSearch(new SearchProps(searchResultsState[0], map((sf_5) => sf_5.Filter, filter_3((sf_4) => sf_4.IsChecked, searchFiltersState[0])), () => {
            const searchTerm_2 = decodeSearchTerm(optToStr(searchStringState[0]));
            const newSearchFrom = (searchToState[0]) | 0;
            const newSearchTo = ((searchToState[0]) + 20) | 0;
            searchFromState[1](newSearchFrom);
            searchToState[1](newSearchTo);
            searchStringState[1](searchTerm_2);
            if (hasReachedMaxResultsState[0]) {
            }
            else {
                startImmediate(singleton.Delay(() => singleton.Bind(loadSearchResultsV2(props.GlobalDependencies.ClientNr, encodeURIComponent(searchTerm_2), map((sf_3) => sf_3.Filter, filter_3((sf_2) => sf_2.IsChecked, searchFiltersState[0])), newSearchFrom, newSearchTo), (_arg_1) => {
                    const result_1 = _arg_1;
                    if (result_1.tag === 1) {
                        searchResultsState[1](new LoadState$2(3, result_1.fields[0]));
                        return singleton.Zero();
                    }
                    else {
                        const searchResults_1 = result_1.fields[0];
                        if (isEmpty(searchResults_1.SearchResult)) {
                            hasReachedMaxResultsState[1](true);
                            return singleton.Zero();
                        }
                        else {
                            searchResultsState[1]((currentExistingSearchResults) => ((currentExistingSearchResults.tag === 2) ? (new LoadState$2(2, new SearchResultV2(append(currentExistingSearchResults.fields[0].SearchResult, searchResults_1.SearchResult), searchResults_1.TotalCount))) : (new LoadState$2(2, searchResults_1))));
                            return singleton.Zero();
                        }
                    }
                })));
            }
        }, props.GlobalDependencies.CountryCode, searchStringState[0])) : ((page.tag === 2) ? LazyPages_InvoiceePage(new InvoiceeProps(props.GlobalDependencies, page.fields[0])) : ((page.tag === 3) ? LazyPages_RegisterInvoiceePage(new RegisterInvoiceeProps(props.GlobalDependencies)) : ((page.tag === 4) ? ((children_4 = [react.createElement("h3", {}, "Not found.")], react.createElement("div", {}, ...children_4))) : ((children = [getTranslation("CustomerContract.Welcome") + "!"], react.createElement("div", {
            ["data-translation"]: "CustomerContract.Welcome",
        }, ...children)))))))], react.createElement("div", {
            className: "container-main container-main--padded",
        }, ...children_6))];
        pageContentHtml = react.createElement(react.Fragment, {}, ...children_8);
    }
    else {
        const children_9 = [getTranslation("CustomerContract.Welcome") + "!"];
        pageContentHtml = react.createElement("div", {
            className: "mt-4 ml-4",
            ["data-translation"]: "CustomerContract.Welcome",
        }, ...children_9);
    }
    return react.createElement("section", {
        className: "fenix-client-wrapper",
    }, pageContentHtml);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\CustomerContract\\View.fs", 322);

